import React from 'react'
import { useFormContext } from 'react-hook-form'
import Form from 'react-bootstrap/Form'
import Pesos from '../components/Pesos'

const combine = (acc, curr) => acc.concat(curr)

function sumOf(arr, property) {
  return arr
    ? arr
        .map((e) => Number(e?.[property]) || 0)
        .reduce((acc, curr) => acc + curr, 0)
    : 0
}

export function Total(props) {
  const sum = sumOf(
    props.values?.reduce(combine, []),
    props.property || 'importe'
  )

  return (
    <Form.Group>
      <Form.Label>{props.title}</Form.Label>
      <p className="text-muted text-normal text-center">
        <Pesos value={parseFloat(sum) || 0} />
      </p>
    </Form.Group>
  )
}

function getTotal(tasas, rp) {
  const alicuotas = sumOf(tasas, 'total')
  const sum = sumOf(rp?.reduce(combine, []), 'importe')

  return [{ importe: alicuotas - sum }]
}

export function TotalBimestreFA({ titulo, bimestre }) {
  const { watch } = useFormContext()

  const w = watch(bimestre)
  const b = w && Object.values(w).flatMap((x) => Object.values(x))
  const retenciones = b?.map((b) => b.retenciones)
  const percepciones = b?.map((b) => b.percepciones)

  const total = getTotal(b, retenciones?.concat(percepciones))

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase mb-1 mt-5">
        {titulo}
      </h6>
      <Form.Row className="container mb-5 d-flex justify-content-between">
        {[
          {
            title: 'Tasas + FSP',
            values: b,
            property: 'total'
          },
          { title: 'Retenciones', values: retenciones },
          { title: 'Percepciones', values: percepciones },
          { title: 'Total', values: total }
        ].map((props, index) => (
          <Total key={index} {...props} />
        ))}
      </Form.Row>
    </>
  )
}

export function TotalAnualFA() {
  const { watch } = useFormContext()

  // BIG HACK! Por como está estructurado el state del formulario, de esta
  // manera puedo obtener los valores directos en un array plano donde cada
  // objeto representa una actividad en un bimestre
  const state = watch()
  const bimestres = Object.values(state)
    .flatMap((x) => Object.values(x))
    .flatMap((x) => Object.values(x))

  const percepciones = bimestres.map((b) => b.percepciones)
  const retenciones = bimestres.map((b) => b.retenciones)

  const total = getTotal(bimestres, percepciones.concat(retenciones))

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase mb-1 mt-5">
        Total Anual
      </h6>
      <Form.Row className="container mb-5 d-flex justify-content-around">
        {[
          {
            title: 'Tasas + FSP',
            values: bimestres,
            property: 'total'
          },
          { title: 'Retenciones', values: retenciones },
          { title: 'Percepciones', values: percepciones },
          { title: 'Total', values: total }
        ].map((props, index) => (
          <Total key={index} {...props} />
        ))}
      </Form.Row>
    </>
  )
}

export function TotalBimestre({ titulo, bimestre, title1, title2 }) {
  const { watch } = useFormContext()
  const stateBimestre = watch(bimestre, {})

  const values1 = stateBimestre.legajos?.flatMap((legajo) => legajo?.[title1])
  const values2 = stateBimestre.legajos?.flatMap((legajo) => legajo?.[title2])

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase mb-1 mt-5">
        {titulo}
      </h6>
      <Form.Row className="container mb-5 d-flex justify-content-between">
        {[
          { title: title1, values: values1 },
          { title: title2, values: values2 },
          { title: 'Total', values: values1?.concat(values2) }
        ].map((props, index) => (
          <Total key={index} {...props} />
        ))}
      </Form.Row>
    </>
  )
}

export function TotalAnual({ title1, title2 }) {
  const { watch } = useFormContext()
  const state = watch()
  const bimestres = Object.entries(state).map(([_, values], i) => values)

  const values1 = bimestres.map((bimestre) => {
    return bimestre?.legajos?.flatMap((legajo) => legajo?.[title1])
  })
  const values2 = bimestres.map((bimestre) => {
    return bimestre?.legajos?.flatMap((legajo) => legajo?.[title2])
  })

  const values3 = values1.concat(values2)

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase mb-1 mt-5">
        Total Anual
      </h6>
      <Form.Row className="container mb-5 d-flex justify-content-around">
        {[
          { title: title1, values: values1 },
          { title: title2, values: values2 },
          { title: 'Total', values: values3 }
        ].map((props, index) => (
          <Total key={index} {...props} />
        ))}
      </Form.Row>
    </>
  )
}

export function TotalPagoBimestre({ titulo, watch, bimestre }) {
  const b = watch(bimestre)
  return (
    <>
      <h6 className="text-muted text-normal text-uppercase mb-1 mt-5">
        {titulo}
      </h6>
      <Form.Row className="container mb-5 d-flex justify-content-between">
        {[
          {
            values: Object.values(b?.pagos)
          }
        ].map((props, index) => (
          <Total key={index} {...props} />
        ))}
      </Form.Row>
    </>
  )
}

export function TotalPagoAnual({ watch }) {
  const state = watch()

  const values = Object.values(state)
    .map((b) => Object.values(b?.pagos))
    .reduce(combine, [])

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase mb-1">
        Total Anual
      </h6>
      <Form.Row className="container">
        <Total {...{ values }} />
      </Form.Row>
    </>
  )
}
